var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26835 8.86957C3.94765 8.86957 3.62695 8.78042 3.36456 8.57242L0.390803 6.22495C-0.046515 5.86837 -0.133978 5.21464 0.215876 4.76892C0.56573 4.3232 1.20713 4.23405 1.64445 4.59063L4.2392 6.61124L9.77661 0.331506C10.1556 -0.084502 10.797 -0.114217 11.2052 0.272076C11.6133 0.658368 11.6425 1.31209 11.2635 1.7281L5.31791 8.45356C5.02637 8.75071 4.64736 8.86957 4.26835 8.86957Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.4557e81db3d7ccc65b85299aa6a60aa1.svg";